<template>
  <div
    :class="
      !position
        ? visibility.show || visibility.name === name
          ? 'dropdown ml-0 full-width is-active'
          : 'dropdown ml-0 full-width'
        : visibility.show || visibility.name === name
        ? 'dropdown ml-0 full-width is-up is-right is-active'
        : 'dropdown ml-0 full-width is-up is-right '
    "
    @mouseleave="handleVisibility(false)"
  >
    <div class="dropdown-trigger full-width">
      <button
        :disabled="loading"
        class="button is-small borderColor full-width"
        :style="!customStyle ? '' : customStyle"
        aria-haspopup="true"
        aria-controls="dropdown-menu"
        @click="handleVisibility(!visibility.show)"
      >
        <span class="text-hidden">{{
          name == "currentLimit" ? value : Title
        }}</span>
        <span class="icon is-small">
          <i
            :class="!position ? 'fa fa-angle-down' : 'fa fa-angle-up'"
            aria-hidden="true"
          ></i>
        </span>
      </button>
    </div>
    <div
      class="dropdown-menu"
      id="dropdown-menu"
      role="menu"
      style="width: 100%; min-width: 50px"
    >
      <div class="dropdown-content is-scroll">
        <a
          href="#"
          class="dropdown-item is-font-size-small"
          style="margin-bottom: 5px"
          v-for="data in dataSource.filter((x) => x.value != value)"
          :key="data.value"
          @click="
            change(name, data.value);
            handleVisibility(!visibility.show);
          "
        >
          {{ data.label }}
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Dropdown",
  props: [
    "Title",
    "dataSource",
    "value",
    "change",
    "name",
    "customStyle",
    "position",
    "disable",
    "loading",
  ],
  data() {
    return {
      visibility: {
        show: false,
        name: "",
      },
    };
  },
  methods: {
    handleVisibility(visibility) {
      this.visibility = {
        show: visibility,
        name: name,
      };
    },
  },
};
</script>

<style>
a.dropdown-item,
button.dropdown-item {
  padding-right: 1rem;
  text-align: inherit;
  white-space: initial;
  width: 100%;
}

.full-width {
  width: 100%;
}

.text-hidden {
  width: 190px;
  overflow: hidden;
  text-overflow: ellipsis;
}

.is-scroll {
  max-height: 200px;
  overflow: auto;
}

.is-font-size-small {
  font-size: 0.75rem;
}

.borderColor {
  border-color: rgb(100 121 143 / 12%);
}

.button.borderColor:hover {
  border-color: #e4e4e4 !important;
}
</style>


// WEBPACK FOOTER //
// src/components/OverallReporting/Dropdown.vue